import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { storage, db } from '../../firebase';

import './index.css';

function DropDownMenu({ postId, email }) {
  const [open, setOpen] = useState(false);
  const [flag, setFlag] = useState(false);
  const container = useRef(null);
  const userEmail = useSelector((state) => state.Dropdown.value);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    if (userEmail === email) {
      setFlag(true);
    }
    return () => {
      // clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const onDelete = () => {
    if (userEmail === email) {
      db.collection('posts')
        .doc(postId)
        .delete()
        .then(function () {
          console.log('Document successfully deleted!');
        })
        .catch(function (error) {
          console.error('Error removing document: ', error);
        });

      storage
        .ref(`avatars/${email}-avatar.png`)
        .delete();

    } else {
      alert("You don't have a permission to delete this post!");
    }
  };

  return (
    <div className='container' ref={container}>
      {flag && (
        <button
          className='container-list-item'
          type='button'
          class='button'
          onClick={() => setOpen(!open)}>
          ...
        </button>
      )}
      {open && (
        <div class='dropdown-wrapper'>
          <ul class='dropdown-menu'>
            <li className='container-list-item' onClick={() => onDelete()}>
              Delete
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default DropDownMenu;
